export const SIGN_IN = 'SIGN_IN';
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS';
export const SIGN_IN_FAILURE = 'SIGN_IN_FAILURE';

export const VERIFY_CODE = 'VERIFY_CODE';
export const VERIFY_CODE_SUCCESS = 'VERIFY_CODE_SUCCESS';
export const VERIFY_CODE_FAILURE = 'VERIFY_CODE_FAILURE';

export const FORGOT_PWD = 'FORGOT_PWD';
export const FORGOT_PWD_SUCCESS = 'FORGOT_PWD_SUCCESS';
export const FORGOT_PWD_FAILURE = 'FORGOT_PWD_FAILURE';

export const SIGN_OUT = 'SIGN_OUT';
export const SIGN_OUT_SUCCESS = 'SIGN_OUT_SUCCESS';
export const SIGN_OUT_FAILURE = 'SIGN_OUT_FAILURE';

export const MENU_CHANGE = 'MENU_CHANGE';
export const SUB_MENU_CHANGE = 'SUB_MENU_CHANGE';

export const FETCH_COUNTRY_DETAILS = 'FETCH_COUNTRY_DETAILS';
export const FETCH_COUNTRY_DETAILS_SUCCESS = 'FETCH_COUNTRY_DETAILS_SUCCESS';
export const FETCH_COUNTRY_DETAILS_FAILURE = 'FETCH_COUNTRY_DETAILS_FAILURE';

export const FETCH_LOCATION_DETAILS = 'FETCH_LOCATION_DETAILS';
export const FETCH_LOCATION_DETAILS_SUCCESS = 'FETCH_LOCATION_DETAILS_SUCCESS';
export const FETCH_LOCATION_DETAILS_FAILURE = 'FETCH_LOCATION_DETAILS_FAILURE';

//BUNIT//
export const FETCH_BUSINESS_DETAILS = 'FETCH_BUSINESS_DETAILS';
export const FETCH_BUSINESS_DETAILS_SUCCESS = 'FETCH_BUSINESS_DETAILS_SUCCESS';
export const FETCH_BUSINESS_DETAILS_FAILURE = 'FETCH_BUSINESS_DETAILS_FAILURE';

export const FETCH_BUSINESS_UNIT_LIST = 'FETCH_BUSINESS_UNIT';
export const FETCH_BUSINESS_UNIT_LIST_SUCCESS = 'FETCH_BUSINESS_UNIT_LIST_SUCCESS';
export const FETCH_BUSINESS_UNIT_LIST_FAILURE = 'FETCH_BUSINESS_UNIT_LIST_FAILURE';

export const FETCH_BUNIT_FILTER_LIST = 'FETCH_BUNIT_FILTER_LIST';
export const FETCH_BUNIT_FILTER_LIST_SUCCESS = 'FETCH_BUNIT_FILTER_LIST_SUCCESS';
export const FETCH_BUNIT_FILTER_LIST_FAILURE = 'FETCH_BUNIT_FILTER_LIST_FAILURE';

export const FETCH_BUSINESS_UNIT_DETAILS = 'FETCH_BUSINESS_UNIT_DETAILS';
export const FETCH_BUSINESS_UNIT_DETAILS_SUCCESS = 'FETCH_BUSINESS_UNIT_DETAILS_SUCCESS';
export const FETCH_BUSINESS_UNIT_DETAILS_FAILURE = 'FETCH_BUSINESS_UNIT_DETAILS_FAILURE';

export const CREATE_BUNIT = 'CREATE_BUNIT';
export const CREATE_BUNIT_SUCCESS = 'CREATE_BUNIT_SUCCESS';
export const CREATE_BUNIT_FAILURE = 'CREATE_BUNIT_FAILURE';

export const UPDATE_BUNIT = 'UPDATE_BUNIT';
export const UPDATE_BUNIT_SUCCESS = 'UPDATE_BUNIT_SUCCESS';
export const UPDATE_BUNIT_FAILURE = 'UPDATE_BUNIT_FAILURE';

export const RESET_BUNIT = 'RESET_BUNIT';
export const RESET_PROFILE = 'RESET_PROFILE';


export const DELETE_BUNIT = 'DELETE_BUNIT';
export const DELETE_BUNIT_SUCCESS = 'DELETE_BUNIT_SUCCESS';
export const DELETE_BUNIT_FAILURE = 'DELETE_BUNIT_FAILURE';

export const EXPORT_BUNIT_DATA = 'EXPORT_BUNIT_DATA';
export const EXPORT_BUNIT_DATA_SUCCESS = 'EXPORT_BUNIT_DATA_SUCCESS';
export const EXPORT_BUNIT_DATA_FAILURE = 'EXPORT_BUNIT_DATA_FAILURE';

//BUNIT//

//CHARITABLE ACTIVITY
export const FETCH_CHARITY_ACTIVITY_LIST = 'FETCH_CHARITY_ACTIVITY';
export const FETCH_CHARITY_ACTIVITY_LIST_SUCCESS = 'FETCH_CHARITY_ACTIVITY_LIST_SUCCESS';
export const FETCH_CHARITY_ACTIVITY_LIST_FAILURE = 'FETCH_CHARITY_ACTIVITY_LIST_FAILURE';

export const FETCH_RECENT_CHARITY_ACTIVITY_LIST = 'FETCH_RECENT_CHARITY_ACTIVITY';
export const FETCH_RECENT_CHARITY_ACTIVITY_LIST_SUCCESS = 'FETCH_RECENT_CHARITY_ACTIVITY_LIST_SUCCESS';
export const FETCH_RECENT_CHARITY_ACTIVITY_LIST_FAILURE = 'FETCH_RECENT_CHARITY_ACTIVITY_LIST_FAILURE';

export const FETCH_CHARITY_ACTIVITY_FILTER_LIST = 'FETCH_CHARITY_ACTIVITY_FILTER_LIST';
export const FETCH_CHARITY_ACTIVITY_FILTER_LIST_SUCCESS = 'FETCH_CHARITY_ACTIVITY_FILTER_LIST_SUCCESS';
export const FETCH_CHARITY_ACTIVITY_FILTER_LIST_FAILURE = 'FETCH_CHARITY_ACTIVITY_FILTER_LIST_FAILURE';

export const FETCH_CHARITY_ACTIVITY_DETAILS = 'FETCH_CHARITY_ACTIVITY_DETAILS';
export const FETCH_CHARITY_ACTIVITY_DETAILS_SUCCESS = 'FETCH_CHARITY_ACTIVITY_DETAILS_SUCCESS';
export const FETCH_CHARITY_ACTIVITY_DETAILS_FAILURE = 'FETCH_CHARITY_ACTIVITY_DETAILS_FAILURE';

export const CREATE_CHARITY_ACTIVITY = 'CREATE_CHARITY_ACTIVITY';
export const CREATE_CHARITY_ACTIVITY_SUCCESS = 'CREATE_CHARITY_ACTIVITY_SUCCESS';
export const CREATE_CHARITY_ACTIVITY_FAILURE = 'CREATE_CHARITY_ACTIVITY_FAILURE';

export const UPDATE_CHARITY_ACTIVITY = 'UPDATE_CHARITY_ACTIVITY';
export const UPDATE_CHARITY_ACTIVITY_SUCCESS = 'UPDATE_CHARITY_ACTIVITY_SUCCESS';
export const UPDATE_CHARITY_ACTIVITY_FAILURE = 'UPDATE_CHARITY_ACTIVITY_FAILURE';

export const DELETE_CHARITY_ACTIVITY = 'DELETE_CHARITY_ACTIVITY';
export const DELETE_CHARITY_ACTIVITY_SUCCESS = 'DELETE_CHARITY_ACTIVITY_SUCCESS';
export const DELETE_CHARITY_ACTIVITY_FAILURE = 'DELETE_CHARITY_ACTIVITY_FAILURE';

export const UPLOAD_FILES = 'UPLOAD_FILES';
export const UPLOAD_FILES_SUCCESS = 'UPLOAD_FILES_SUCCESS';
export const UPLOAD_FILES_FAILURE = 'UPLOAD_FILES_FAILURE';

export const EXPORT_CHARITY_DATA = 'EXPORT_CHARITY_DATA';
export const EXPORT_CHARITY_DATA_SUCCESS = 'EXPORT_CHARITY_DATA_SUCCESS';
export const EXPORT_CHARITY_DATA_FAILURE = 'EXPORT_CHARITY_DATA_FAILURE';
//CHARITABLE ACTIVITY

//USER MANAGEMENT ACTIVITY
export const FETCH_USER_MGT_LIST = 'FETCH_USER_MGT';
export const FETCH_USER_MGT_LIST_SUCCESS = 'FETCH_USER_MGT_LIST_SUCCESS';
export const FETCH_USER_MGT_LIST_FAILURE = 'FETCH_USER_MGT_LIST_FAILURE';

export const FETCH_USER_MGT_FILTER_LIST = 'FETCH_USER_MGT_FILTER_LIST';
export const FETCH_USER_MGT_FILTER_LIST_SUCCESS = 'FETCH_USER_MGT_FILTER_LIST_SUCCESS';
export const FETCH_USER_MGT_FILTER_LIST_FAILURE = 'FETCH_USER_MGT_FILTER_LIST_FAILURE';

export const FETCH_SELF_REG_FILTER_LIST = 'FETCH_SELF_REG_FILTER_LIST';
export const FETCH_SELF_REG_FILTER_LIST_SUCCESS = 'FETCH_SELF_REG_FILTER_LIST_SUCCESS';
export const FETCH_SELF_REG_FILTER_LIST_FAILURE = 'FETCH_SELF_REG_FILTER_LIST_FAILURE';

export const FETCH_USER_MGT_DETAILS = 'FETCH_USER_MGT_DETAILS';
export const FETCH_USER_MGT_DETAILS_SUCCESS = 'FETCH_USER_MGT_DETAILS_SUCCESS';
export const FETCH_USER_MGT_DETAILS_FAILURE = 'FETCH_USER_MGT_DETAILS_FAILURE';

export const CREATE_USER_MGT = 'CREATE_USER_MGT';
export const CREATE_USER_MGT_SUCCESS = 'CREATE_USER_MGT_SUCCESS';
export const CREATE_USER_MGT_FAILURE = 'CREATE_USER_MGT_FAILURE';

export const UPDATE_USER_MGT = 'UPDATE_USER_MGT';
export const UPDATE_USER_MGT_SUCCESS = 'UPDATE_USER_MGT_SUCCESS';
export const UPDATE_USER_MGT_FAILURE = 'UPDATE_USER_MGT_FAILURE';

export const DELETE_USER_MGT = 'DELETE_USER_MGT';
export const DELETE_USER_MGT_SUCCESS = 'DELETE_USER_MGT_SUCCESS';
export const DELETE_USER_MGT_FAILURE = 'DELETE_USER_MGT_FAILURE';

export const FETCH_ROLES_LOV_SUCCESS = "FETCH_ROLES_LOV_SUCCESS"
export const FETCH_ROLES_LOV_FAILURE = "FETCH_ROLES_LOV_FAILURE"

export const GET_USER_MGT = "GET_USER_MGT";
export const GET_USER_MGT_SUCCESS = 'GET_USER_MGT_SUCCESS';
export const GET_USER_MGT_FAILURE = 'GET_USER_MGT_FAILURE';

export const FETCH_COUNTRIES_LIST_SUCCESS = 'FETCH_COUNTRIES_LIST_SUCCESS';
export const FETCH_COUNTRIES_LIST_FAILURE = 'FETCH_COUNTRIES_LIST_FAILURE';

export const FETCH_YEAR_SUCCESS = 'FETCH_YEAR_SUCCESS';
export const FETCH_YEAR_FAILURE = 'FETCH_YEAR_FAILURE';

export const TRIGGER_MAIL = 'TRIGGER_MAIL';
export const TRIGGER_MAIL_SUCCESS = 'TRIGGER_MAIL_SUCCESS';
export const TRIGGER_MAIL_FAILURE = 'TRIGGER_MAIL_FAILURE';

export const RESET_USER_PROFILE = 'RESET_USER_PROFILE';


export const EXPORT_USER_DATA = 'EXPORT_USER_DATA';
export const EXPORT_USER_DATA_SUCCESS = 'EXPORT_USER_DATA_SUCCESS';
export const EXPORT_USER_DATA_FAILURE = 'EXPORT_USER_DATA_FAILURE';

export const  RESET_MY_FORGOT_PWD_SUCCESS  =  "RESET_MY_FORGOT_PWD_SUCCESS";
export const  RESET_MY_FORGOT_PWD_FAILURE  =  "RESET_MY_FORGOT_PWD_FAILURE";

export const  RESET_MY_PWD_SUCCESS  =  "RESET_MY_PWD_SUCCESS";
export const  RESET_MY_PWD_FAILURE  =  "RESET_MY_PWD_FAILURE";

export const  TOKEN_AUTH_SUCCESS  =  "TOKEN_AUTH_SUCCESS";
export const  TOKEN_AUTH_FAILURE  =  "TOKEN_AUTH_FAILURE";

export const FETCH_AUDITLOG_LIST = "FETCH_AUDITLOG_LIST";
export const FETCH_AUDITLOG_LIST_SUCCESS = "FETCH_AUDITLOG_LIST_SUCCESS";
export const FETCH_AUDITLOG_LIST_FAILURE = "FETCH_AUDITLOG_LIST_FAILURE";

export const FETCH_AUDITUSER_LIST = "FETCH_AUDITUSER_LIST";
export const FETCH_AUDITUSER_LIST_SUCCESS = "FETCH_AUDITUSER_LIST_SUCCESS";
export const FETCH_AUDITUSER_LIST_FAILURE = "FETCH_AUDITUSER_LIST_FAILURE";

export const GET_ADMIN_DETAILS = "GET_ADMIN_DETAILS";
export const GET_ADMIN_DETAILS_SUCCESS = "GET_ADMIN_DETAILS_SUCCESS";
export const GET_ADMIN_DETAILS_FAILURE = "GET_ADMIN_DETAILS_FAILURE";


export const UPDATE_ADMIN_DETAILS = "UPDATE_ADMIN_DETAILS";
export const UPDATE_ADMIN_DETAILS_SUCCESS = "UPDATE_ADMIN_DETAILS_SUCCESS";
export const UPDATE_ADMIN_DETAILS_FAILURE = "UPDATE_ADMIN_DETAILS_FAILURE";

export const FETCH_GALLERY_DETAILS =  "FETCH_GALLERY_DETAILS";
export const FETCH_GALLERY_DETAILS_SUCCESS =  "FETCH_GALLERY_DETAILS_SUCCESS";
export const FETCH_GALLERY_DETAILS_FAILURE =  "FETCH_GALLERY_DETAILS_FAILURE";

export const PRE_SIGN_IN = 'PRE_SIGN_IN';
export const PRE_SIGN_IN_SUCCESS = 'PRE_SIGN_IN_SUCCESS';
export const PRE_SIGN_IN_FAILURE = 'PRE_SIGN_IN_FAILURE';

export const AZURE_SIGN_IN = 'AZURE_SIGN_IN';
export const AZURE_SIGN_IN_SUCCESS = 'AZURE_SIGN_IN_SUCCESS';
export const AZURE_SIGN_IN_FAILURE = 'AZURE_SIGN_IN_FAILURE';
export const AZURE_LOGOUT = 'AZURE_LOGOUT';

export const SIGN_UP = 'SIGN_UP';
export const SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS';
export const SIGN_UP_FAILURE = 'SIGN_UP_FAILURE';
